import React, { Component } from "react";
import PropTypes from "prop-types";
import EmployerCandidateActions from "./EmployerCandidateActions";
import RecruiterCandidateActions from "./RecruiterCandidateActions";

class CandidateActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      action: "send_message",
      message: "",
      selectedAction: "",
      fileSelected: false,
      resetButtonFocus: false,
      actionDate: null,
      actionAt: null,
      actionEndAt: null,
      attachmentPopupActive: false,
      finalSalary: undefined,
      formSubmitting: false,
    };

    this.fileInput = React.createRef();
    this.submitButton = React.createRef();
  }

  optionHandle = (e) => {
    const { toggleActionsDropdown } = this.props;
    const action = e.target.getAttribute("value");
    const selectedAction = e.target.innerHTML;

    this.setState({
      selectedAction,
      action,
    });

    toggleActionsDropdown();
  };

  removeActionHandle = () => {
    this.setState({
      selectedAction: "",
      actionDate: null,
      actionAt: null,
      actionEndAt: null,
      action: "send_message",
    });
  };

  handleMessageChange = (event) => {
    this.setState({ message: event.target.value });
  };

  attachmentChange = () => {
    this.setState({ fileSelected: true });
  };

  removeAttachment = () => {
    this.setState({ fileSelected: false });
    this.fileInput.current.value = "";
  };

  handleDateChange = (date) => {
    const { actionAt, actionEndAt } = this.state;

    this.setState({
      actionDate: date,
      actionAt: this.updateDateExcludingTime(actionAt, date),
      actionEndAt: this.updateDateExcludingTime(actionEndAt, date),
    });
  };

  updateDateExcludingTime = (dateToUpdate, date) => {
    if (dateToUpdate === null || date === null) return null;

    const newDate = new Date(dateToUpdate);
    newDate.setDate(date.getDate());

    return newDate;
  };

  handleStartTimeChange = (date) => {
    const actionAt = this.actionDateWithCustomTime(date);

    this.setState({ actionAt });
  };

  handleEndTimeChange = (date) => {
    const actionEndAt = this.actionDateWithCustomTime(date);

    this.setState({ actionEndAt });
  };

  actionDateWithCustomTime = (date) => {
    const { actionDate } = this.state;
    if (actionDate === null) return null;

    const newDate = new Date(actionDate);

    newDate.setHours(date.getHours());
    newDate.setMinutes(date.getMinutes());
    newDate.setSeconds(date.getSeconds());

    return newDate;
  };

  handleAttachmentPopup = () => {
    const { attachmentPopupActive } = this.state;
    this.setState({ attachmentPopupActive: !attachmentPopupActive });
  };

  handleFinalSalaryInput = (e) =>
    this.setState({ finalSalary: Number(e.target.value) });

  scrollAfterMessageSent = () => {
    const element = document.getElementById("scroller");
    element.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  handleSubmit = (event, rejectionData = null) => {
    event.preventDefault();
    const { updateCandidateStatus } = this.props;
    const { action, actionAt, actionEndAt, message, finalSalary } = this.state;
    const attachment = this.fileInput.current.files[0];
    this.setState({ resetButtonFocus: false, formSubmitting: true });

    const submitData = {
      action,
      actionAt,
      actionEndAt,
      message,
      attachment,
      finalSalary,
    };

    // Add rejection data if provided (for rejected_candidate action)
    if (rejectionData) {
      submitData.rejectionData = rejectionData;
    }

    updateCandidateStatus(submitData).then((result) => {
      if (result) {
        this.setState({
          selectedAction: "",
          action: "send_message",
          message: "",
          fileSelected: false,
          resetButtonFocus: true,
          attachmentPopupActive: false,
          finalSalary: undefined,
        });
        this.fileInput.current.value = "";
        this.scrollAfterMessageSent();
      }
      this.setState({ formSubmitting: false });
    });
  };

  render() {
    const {
      selectedAction,
      message,
      fileSelected,
      resetButtonFocus,
      actionDate,
      actionAt,
      actionEndAt,
      action,
      attachmentPopupActive,
      finalSalary,
      formSubmitting,
    } = this.state;

    const {
      toggleActionsDropdown,
      actionsDropdown,
      offerMade,
      isEmployer,
      jobCurrencySymbol,
      jobFilled,
      jobStatus,
      isRejected,
    } = this.props;

    const candidateProps = {
      actionsDropdown,
      action,
      attachmentChange: this.attachmentChange,
      fileInput: this.fileInput,
      fileSelected,
      handleMessageChange: this.handleMessageChange,
      handleSubmit: this.handleSubmit,
      jobStatus,
      message,
      offerMade,
      jobFilled,
      optionHandle: this.optionHandle,
      removeActionHandle: this.removeActionHandle,
      removeAttachment: this.removeAttachment,
      resetButtonFocus,
      selectedAction,
      toggleActionsDropdown,
      handleFinalSalaryInput: this.handleFinalSalaryInput,
    };

    return isEmployer ? (
      <EmployerCandidateActions
        {...candidateProps}
        handleAttachmentPopup={this.handleAttachmentPopup}
        attachmentPopupActive={attachmentPopupActive}
        isEmployer={isEmployer}
        jobStatus={jobStatus}
        formSubmitting={formSubmitting}
      />
    ) : (
      <RecruiterCandidateActions
        {...candidateProps}
        action={action}
        actionDate={actionDate}
        actionAt={actionAt}
        actionEndAt={actionEndAt}
        handleDateChange={this.handleDateChange}
        handleStartTimeChange={this.handleStartTimeChange}
        handleEndTimeChange={this.handleEndTimeChange}
        isRejected={isRejected}
        handleAttachmentPopup={this.handleAttachmentPopup}
        attachmentPopupActive={attachmentPopupActive}
        finalSalary={finalSalary}
        jobCurrencySymbol={jobCurrencySymbol}
        jobStatus={jobStatus}
        formSubmitting={formSubmitting}
      />
    );
  }
}

CandidateActions.propTypes = {
  updateCandidateStatus: PropTypes.func.isRequired,
  toggleActionsDropdown: PropTypes.func.isRequired,
  actionsDropdown: PropTypes.bool.isRequired,
  offerMade: PropTypes.bool.isRequired,
  isEmployer: PropTypes.bool.isRequired,
  jobCurrencySymbol: PropTypes.string.isRequired,
  jobFilled: PropTypes.bool,
  jobStatus: PropTypes.string.isRequired,
  isRejected: PropTypes.bool.isRequired,
};

CandidateActions.defaultProps = {
  jobFilled: PropTypes.isNull,
};

export default CandidateActions;
